import { Fragment, useEffect, useMemo, useState } from "react";
import {
  // Popover,
  // ButtonBase,
  Typography,
  useTheme,
  Button,
  Paper,
  Chip,
} from "@mui/material";
import utils from "utils";
// import EventNoteRoundedIcon from "@mui/icons-material/EventNoteRounded";
import { Link } from "react-router-dom";
// import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
// import { PopperInner } from "./AppointmentEventItemStyles";
import { format } from "date-fns";
import { HOUR_FORMAT } from "Common/constant";
import Stack from "@mui/material/Stack";
import moment from "moment";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";
import dayjs from "dayjs";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} placement="top-start" classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 400,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

const AppointmentEventItem = ({
  event,
  handleJoinNow,
  setPatientDetail,
  user_details,
}) => {
  // const { events, setEvents, locale, triggerDialog, triggerLoading } =
  //   useScheduler();

  let startMomentObj = moment(new Date(event.start));
  let endMomentObj = moment(new Date(event.end));

  const currentDateWRTTZ = new Date(
    dayjs(utils.TimezoneOffsetConversion()).format("YYYY-MM-DD HH:mm:ss")
  );

  const [isCurrentTimeAppt, setIsCurrentTimeAppt] = useState(
    moment(new Date(currentDateWRTTZ)).isBetween(
      startMomentObj.subtract(5, "minutes"),
      endMomentObj,
      "minutes",
      "[]"
    )
  );

  const hFormat = HOUR_FORMAT === "12" ? "hh:mm a" : "HH:mm";
  const theme = useTheme();

  // const [ancholElRef, setAnchorElRef] = useState(null);
  // const [deleteConfirm, setDeleteConfirm] = useState(false);

  // const triggerEventViewer = (el) => {
  //   if (!el && deleteConfirm) {
  //     setDeleteConfirm(false);
  //   }
  //   setAnchorElRef(el || null);
  // };

  // const handleDelete = async () => {
  //   try {
  //     triggerLoading(true);
  //     let deletedId = event.event_id;
  //     // Trigger custom/remote when provided

  //     if (deletedId) {
  //       const filteredEvents = events.filter(
  //         (event) => event.event_id !== deletedId
  //       );
  //       setEvents(filteredEvents);
  //       triggerEventViewer();
  //     }
  //   } catch (error) {
  //     // console.error(error);
  //   } finally {
  //     triggerLoading(false);
  //   }
  // };

  // const renderViewer = () => {
  //   return (
  //     <PopperInner>
  //       <div
  //         style={{
  //           background: event.color || theme.palette.primary.main,
  //           color: theme.palette.primary.contrastText,
  //         }}
  //       >
  //         <div className="rs__popper_actions">
  //           <div>
  //             <IconButton
  //               size="small"
  //               onClick={() => {
  //                 triggerEventViewer();
  //               }}
  //             >
  //               <ClearRoundedIcon
  //               // color="disabled"
  //               />
  //             </IconButton>
  //           </div>
  //           <EventViewerActions
  //             event={event}
  //             onDelete={handleDelete}
  //             onEdit={() => {
  //               triggerEventViewer();
  //               triggerDialog(true, event);
  //             }}
  //             direction="rtl"
  //             deletable={true}
  //             editable={true}
  //           />
  //         </div>
  //         <Typography style={{ padding: "5px 0" }} noWrap>
  //           {event.title}
  //         </Typography>
  //       </div>
  //       <div style={{ padding: "5px 10px" }}>
  //         <Typography
  //           style={{ display: "flex", alignItems: "center", gap: 8 }}
  //           color="textSecondary"
  //           variant="caption"
  //           noWrap
  //         >
  //           <EventNoteRoundedIcon />
  //           {`${format(event.start, `dd MMMM yyyy ${hFormat}`, {
  //             locale: locale,
  //           })} - ${format(event.end, `dd MMMM yyyy ${hFormat}`, {
  //             locale: locale,
  //           })}`}
  //         </Typography>
  //       </div>
  //     </PopperInner>
  //   );
  // };

  const renderEvent = useMemo(() => {
    let isCareAdmin = user_details.role === "care-admin";
    let item = (
      <div
        style={{
          height: "100%",
          padding: "4px 4px 0px 4px",
          zIndex: 99999,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div>
          <Grid container alignItems="flex-start">
            <Grid
              item
              xs={!isCareAdmin && isCurrentTimeAppt && event.showJoin ? 6 : 12}
            >
              <div
                className={
                  isCareAdmin ? "patient-name-link-care" : "patient-name-link"
                }
                onClick={() => setPatientDetail(event.patient_id)}
              >
                <HtmlTooltip
                  // title={
                  //   <>
                  //     <Typography>
                  //       {utils.FormatName(utils.getDisplayName(event.patient_name, event.patient_last_name))}
                  //     </Typography>
                  //   </>
                  // }
                >
                  {isCareAdmin ? (
                    <span className="patient-name-link-txt">
                      {utils.FirstNameLastNameLink(utils.FormatName(utils.getDisplayName(event?.patient_name, event.patient_last_name)), "70px") || ""}
                    </span>
                  ) : (
                    <Link
                      className="patient-name-link-txt"
                      to={{
                        pathname: `${user_details?.baseUrl}/patient-detail`,
                        state: { data: event },
                      }}
                    >
                      {utils.FirstNameLastNameLink(utils.FormatName(utils.getDisplayName(event?.patient_name, event?.patient_last_name)), "70px") || ""}
                    </Link>
                  )}
                </HtmlTooltip>
              </div>
            </Grid>
            {isCurrentTimeAppt && !isCareAdmin && event.showJoin && (
              <Grid item xs={6}>
                <div className="calendar_button_div">
                  <Button
                    style={{
                      height: "2.6em",
                      fontSize: "11px",
                      background: "#107569",
                      color: "#FFFFFF",
                    }}
                    variant="contained"
                    // endIcon={<VideoCallIcon />}
                    // onClick={() => handleJoinNow(event.event_id)}
                    onClick={() => handleJoinNow(event)}
                  >
                    join
                  </Button>
                </div>
              </Grid>
            )}
          </Grid>
          <Typography
            style={{
              fontSize: 12,
              color: "#344054",
              marginTop: "10px",
            }}
          >
            {`${format(event.start, hFormat)} - ${format(
              event.endLabel,
              hFormat
            )}`}
          </Typography>
          {/* {isCurrentTimeAppt ? (
          <Button
            style={{ height: "2.6em", fontSize: "11px", background: "#5D2F6F" }}
            variant="contained"
            endIcon={<VideoCallIcon />}
            onClick={() => handleJoinNow(event.event_id)}
          >
            join
          </Button>
        ) : (
          <Typography style={{ fontSize: 13, marginTop: "5px" }} noWrap>
            {`${format(event.start, hFormat, {
              locale,
            })} - ${format(event.end, hFormat, { locale })}`}
          </Typography>
        )} */}
        </div>
      </div>
    );

    return (
      <Paper
        key={`${event.start.getTime()}_${event.end.getTime()}`}
        style={{
          width: "100%",
          height: "100%",
          background: "#F9FAFB",
          overflow: "hidden",
        }}
      >
        {item}
      </Paper>
    );
    // eslint-disable-next-line
  }, [event, theme.palette, isCurrentTimeAppt]);

  useEffect(() => {
    if (isCurrentTimeAppt) {
      const currentTime = moment(new Date(currentDateWRTTZ));
      const endTime = moment(event.end);
      const timeToComplete = endTime.diff(currentTime);
      const timer = setTimeout(() => {
        setIsCurrentTimeAppt(false);
      }, timeToComplete);

      return () => {
        clearTimeout(timer);
      };
    }
  }, []);

  return (
    <Fragment>
      {/* Event */}
      {renderEvent}

      {/* Viewer */}
      {/* <Popover
        open={Boolean(ancholElRef)}
        anchorEl={ancholElRef}
        onClose={() => {
          triggerEventViewer();
        }}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {renderViewer()}
      </Popover> */}
    </Fragment>
  );
};

export default AppointmentEventItem;
